import Vue from 'vue'
import ConfirmModal from '@/components/ConfirmModal.vue'

let instance = null

function getInstance() {
  if (!instance) {
    const ConfirmConstructor = Vue.extend(ConfirmModal)
    instance = new ConfirmConstructor()
    instance.$mount()
    document.body.appendChild(instance.$el)
  }
  return instance
}

export default {
  install(VueInstance) {
    VueInstance.prototype.$confirm = function (options) {
      if (typeof options === 'string') {
        options = { message: options }
      }
      return getInstance().open(options || {})
    }
  },
}
